module.exports = __webpack_public_path__ + "img/university-of-sydney.066a57ae.png";